export default __webpack_public_path__ + "static/media/img_04.cda3dc2c.svg";